import React from 'react';
import './Footer.css';
import packageInfo from '../../package.json';
import { getDomainConfig } from '../utils/domainConfig';

const Footer = ({ theme }) => {
  const { siteName, company } = getDomainConfig();
  const currentYear = new Date().getFullYear();

  return (
      <footer className={`${theme}`}>
        <p>&copy; {currentYear} {siteName} | v{packageInfo.version}</p>
        <p>This product isn't affiliated with or endorsed by {company} in any way.</p>
      </footer>
  );
}

export default Footer;
